import { ISalaryTicket } from 'src/types/hr_ticket/salaryTicket.type';
import { httpExternal } from 'src/utils/http';

const controller = 'payroll/employee-salaries/payslip';

export const getPayslip = async ({
  verificationCode,
  month,
  year,
  employeeCode
}: {
  verificationCode: string;
  employeeCode: string;
  month?: number;
  year?: number;
}) => {
  return await httpExternal.get<ISalaryTicket>(controller, {
    params: {
      employeeCode,
      verificationCode,
      month,
      year
    }
  });
};
